import React from 'react';
import {Route, Switch} from 'react-router-dom';
import ArticleDetailPage from './article/detail';
import RegisterPage from './about/register';
import {
  SideLayoutAboutCatalogs,
  SideLayoutOrganizationCatalogs,
  SideLayoutSpecialtyCommitteeCatalogs,
  SideLayoutWorkCommitteeCatalogs,
} from '../components/layouts/AppSideLayout';
import ArticleListPage from './article/list';
import IndexPage from './index';
import OrganizationPage from './about/organization';
import ProfileDetailPage from './profile/detail';
import ProfilePaymentPage from './profile/payment';
import AboutCongressPage from './about/congress';
import ProfileCardPage from './profile/card';

export default function AppRouter() {
  return (
    <Switch>
      <Route path={'/article/:id'} component={ArticleDetailPage} />
      <Route path={'/about/register'} component={RegisterPage} />
      <Route path={'/about/organization'} component={OrganizationPage} />
      <Route path={'/about/congress'} component={AboutCongressPage} />
      {SideLayoutAboutCatalogs.list
        .filter(i => i.title !== '在线入会')
        .filter(i => i.title !== '组织机构')
        .map(i => (
          <Route key={i.title} path={i.href} component={() => <ArticleListPage catalogs={i.title} />} />
        ))}
      {SideLayoutWorkCommitteeCatalogs.list.map(i => (
        <Route key={i.title} path={i.href} component={() => <ArticleListPage catalogs={i.title} />} />
      ))}
      {SideLayoutSpecialtyCommitteeCatalogs.list.map(i => (
        <Route key={i.title} path={i.href} component={() => <ArticleListPage catalogs={i.title} />} />
      ))}
      {SideLayoutOrganizationCatalogs.list.map(i => (
        <Route key={i.title} path={i.href} component={() => <ArticleListPage catalogs={i.title} />} />
      ))}
      <Route path={'/activity/summarize'} component={() => <ArticleListPage catalogs={'会议活动总结'} />} />
      <Route path={'/activity/recommend'} component={() => <ArticleListPage catalogs={'推荐会议活动'} />} />
      <Route path={'/notice/list'} component={() => <ArticleListPage catalogs={'最新公告'} />} />
      <Route path={'/partner/list'} component={() => <ArticleListPage catalogs={'团体会员风采'} />} />
      <Route path={'/profile/detail'} component={ProfileDetailPage} />
      <Route path={'/profile/payment'} component={ProfilePaymentPage} />
      <Route path={'/profile/card'} component={ProfileCardPage} />
      <Route path={'/'} component={IndexPage} />
    </Switch>
  );
}
